import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { AddNumberLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumber/layout/AddNumberLayout'
import { HowAddNumber } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumber/ui/HowAddNumber/HowAddNumber'

export const AddNumberRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<AddNumberLayout />}>
        <Route path='/' element={<HowAddNumber />} />
      </Route>
    </RoutesWithNotFound>
  )
}
